"use client";

import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {ButtonSimple} from "@/shared/ui/buttons";
import {assetPath} from "@/shared/utils/asset-path";

import "./parts/styles/links-group.scss";

export function OneTrustPrivacyChoicesButton({label}: {label: string}): JSX.Element {
    return (
        <ButtonSimple
            as="button"
            className="links-group__toggle"
            aria-expanded={false}
            onClick={() => {
                window.OneTrust?.ToggleInfoDisplay();
            }}
            size="sm"
            variant="secondary"
        >
            {label}
            <SmartImage src={assetPath("/images/icons/privacy-choices.svg")} alt="Icon" width={20} height={16} />
        </ButtonSimple>
    );
}
